import {Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, InputLabel, TextField} from '@mui/material'
import {styled} from '@mui/material/styles'

export const StyledDialogTitle = styled(DialogTitle)(() => ({
  padding: '27px'
}))

export const StyledDialogContent = styled(DialogContent)(() => ({
  paddingBottom: '8px'
}))

export const StyledBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center'
}))

export const StyledInputLabel = styled(InputLabel)(() => ({
  marginRight: '16px',
  fontSize: '12px',
  color: 'black',
  fontWeight: 500
}))

export const StyledTextField = styled(TextField, {shouldForwardProp: (prop) => prop !== 'errorMessage'})(
  (errorMessage) => ({
    minWidth: '300px',
    fontSize: '14px',
    borderColor: errorMessage ? 'red' : undefined
  })
)

export const StyledErrorBox = styled(Box)(() => ({
  marginTop: '16px',
  justifyContent: 'center',
  display: 'flex'
}))

export const StyledErrorInputLabel = styled(InputLabel)(() => ({
  fontSize: '12px',
  color: 'red',
  fontWeight: 500
}))

export const StyledDialogActions = styled(DialogActions)(() => ({
  paddingBottom: '16px',
  marginRight: '16px'
}))

export const StyledButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.common.black,
  textTransform: 'none',
  color: theme.palette.common.white,
  '&:disabled': {
    color: theme.palette.common.grey
  },
  '&:hover': {
    backgroundColor: theme.palette.common.black
  }
}))

export const StyledIconButton = styled(IconButton)(({theme}) => ({
  position: 'absolute',
  right: '8px',
  top: '8px',
  color: theme.palette.common.grey
}))
